import { render, staticRenderFns } from "./Concentration.vue?vue&type=template&id=c2fae968&scoped=true"
import script from "./Concentration.vue?vue&type=script&lang=js"
export * from "./Concentration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fae968",
  null
  
)

export default component.exports